/* eslint-disable */
declare global {
  interface Window {
    dataLayer?: any;
  }
}
//We are using this JS file for enabling Analytics and pushing the data to the data layer.
let  analyticsDataLayer = (window.dataLayer = window.dataLayer || []);
// Global addAnalytics function for adding analytic data
/* eslint-disable */
let data = {};
export function sendAnalyticData(eventName, customData, key) {
  if (eventName && customData) {
    data = {
      "event": eventName,
    };
    data[key] = customData;
  }
  if (data) {
    addAnalytics(data);
  }
}
export function sendProductData(eventName, customData) {
  if (eventName && customData) {
    data = {
      "event": eventName,
      "styleNumbersClicked": customData.toString()
    };
  }
  if (data) {
    addAnalytics(data);
  }
}
export function addAnalytics(data) {
  if (analyticsDataLayer) {
    analyticsDataLayer.push(data);
  } else {
    analyticsDataLayer = window.dataLayer = window.dataLayer || [];
    analyticsDataLayer.push(data);
  }
}
//add analytics launch script
export function addAnalyticsLaunchScript(url) {
  if (!document.getElementById("analyticsLaunchJs") && url?.length > 0) {
    const scriptFile = document.createElement("script");
    scriptFile.id = "analyticsLaunchJs";
    scriptFile.src = url;
    document?.head?.appendChild(scriptFile);
  }
}
//reload app
export function reloadApp(url = window.location.href) {
  window.location.href = url;
}

